export const FIBER_INSTALLER = {
  MM: 'MM',
  TESA: 'TESA',
}

export const INSTALLER_DEFAULT = {
  CH_Installation_Point_Provider: FIBER_INSTALLER.MM,
  CH_Installation_Point_Type: null,
}
